import React from "react";
import {
  FooterWrapper,
  FooterContent,
  Logo,
  SocialIcons,
  SocialIcon,
  Hr,
  Conditions,
} from "./styles";

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContent>
        <a href="https://www.babyapesocialclub.com/"><Logo src="logo.png" /></a>
        <SocialIcons>
          <a
            href="https://twitter.com/BabyApe_SC?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
            target="_blank"
            rel="noreferrer"
          >
            <SocialIcon src="twitter-footer.png" />
          </a>
          <a
            href="https://www.instagram.com/babyapesocialclub/?hl=en"
            target="_blank"
            rel="noreferrer"
          >
            <SocialIcon src="instagram.png" />
          </a>
          <a
            href="https://discord.com/invite/2uNZYSKvsw"
            target="_blank"
            rel="noreferrer"
          >
            <SocialIcon src="discord.png" />
          </a>
        </SocialIcons>
      </FooterContent>
      <Hr />
      <Conditions>© 2022 Baby Ape Social Club | All rights reserved</Conditions>
    </FooterWrapper>
  );
};

export default Footer;
